import React, { memo, useState, useMemo } from 'react';
import './index.scss';
import { classnames } from '@core/utils/css';
import { useCourseBuilderContext } from '../../CourseBuilderContext';
import './index.scss';
import { useNonNilObservable } from '@core/utils/hooks/rxjs';
import { Formatter } from '@core/utils/formatter';
import { Text } from '@modules/common/Text';
import { FormText } from '@core/components/form/FormText';
import { openCourseBuilderSettingsOverlay } from '../CourseBuilderSettingsOverlay';
import { toMoment } from '@core/utils/time';
import { Config } from '@config';
import { useHistory, useQueryStringParam } from '@core/router';
import { Button } from '@core/components/Button';
import { openEditProposalOverlay } from '@modules/proposal/EditProposalOverlay';
import { CourseId } from '@business/entities/course';

interface CourseBuilderHeaderProps {
  lastSaved?: number | null;
  canSave: boolean;
  onSave: () => void;
  id: string;
  courseId?: CourseId;
}
export const CourseBuilderHeader = memo((props: CourseBuilderHeaderProps) => {
  const { courseId } = props;
  const returnUrl = useQueryStringParam('returnUrl') || courseId ? `/courses/manage/${courseId}/steps` : '/courses';
  const [isOpen, setOpen] = useState(false);
  const { toggleSidebar, form } = useCourseBuilderContext()!;
  const formValue = useNonNilObservable(form.value$);
  const history = useHistory();

  return (
    <div className={classnames('course-builder-header', { open: isOpen })}>
      <div className="bar-handle" onClick={() => history.push(returnUrl)}>
        <i className="fa fa-arrow-left"></i>
      </div>
      <div className="bar-handle" onClick={toggleSidebar}>
        <i className="fas fa-bars"></i>
      </div>
      <div className="proposal-title">
        <FormText control={form.controls.title} singleLine editable toolbar={false} />
      </div>
      <div className="flex-fill"></div>
      <div className="proposal-header-right">
        <div className="proposal-settings-icon" onClick={() => openCourseBuilderSettingsOverlay({ form })}>
          <i className="fas fa-cog mr-2"></i>
        </div>
        {!!props.lastSaved && <div className="mr-2 text-muted">Last saved {toMoment(props.lastSaved).format('hh:mma')}</div>}
        <Button onClick={props.onSave} disabled={!props.canSave}>
          Save
        </Button>

        <a
          href={courseId ? `/courses/preview/${courseId}?step=${props.id}` : `/courses/lesson/preview/${props.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-secondary ml-2"
        >
          Preview
        </a>
      </div>
    </div>
  );
});
